import styled from 'styled-components';
import Card from '@bit/wavfichacerta.fichacerta.cards.card';

export const Container = styled(Card)`
  padding: .25rem .5rem .25rem .5rem;
  width: ${props => props.width || '99%'};;
  margin: 1rem auto;
  
  @media(max-width: 800px){
    margin-top: .85rem;
    padding: .65rem .6rem;
    width: ${props => props.widthMobile || '100%'};
    background-color: #ffffff;
    border-radius: 12px;
    border: 1px solid rgba(21, 43, 78, 0.1);
    box-shadow: 0 3px 14px rgba(21, 43, 78, 0.1);

    .report-header-mobile-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px 10px;
      align-items: start;
    }

    /* Coluna própria: evita o endereço multilinha “invadir” a linha do grid seguinte (WebViews / subpixel). */
    .report-header-mobile-property-stack {
      grid-column: 1 / -1;
      display: flex;
      flex-direction: column;
      gap: 12px;
      min-width: 0;
      width: 100%;
    }

    .report-header-mobile-rent-type-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      min-width: 0;
      width: 100%;
    }

    .report-header-mobile-item {
      min-width: 0;
      background: #f7f9fc;
      border: 1px solid rgba(21, 43, 78, 0.08);
      border-radius: 10px;
      padding: 7px 8px;
      box-sizing: border-box;
    }

    .report-header-mobile-item--stretch {
      width: 100%;
    }

    .report-header-mobile-item.full {
      grid-column: 1 / -1;
    }

    .report-header-mobile-label {
      display: block;
      color: #4d607b;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.03em;
      margin-bottom: 2px;
      text-transform: uppercase;
      line-height: 1.25;
    }

    .report-header-mobile-value {
      margin: 0;
      color: #152b4e;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.3;
      word-break: break-word;
    }
  }
`;

export const VerticalLine = styled.hr`
  width: 1px; 
  height: 40px;
  border-right: 1px solid #7f7f7f !important;
  margin: 0.1rem 20px;

  @media(min-width: 801px){
    display: none;
  }
`;
